export const allServiceStop = {
    title: '全社サービス緊急停止',
    restart: '全社サービス復活',
    restartMsg: 'この操作はすべての緊急停止したアカウントを復活します。よろしいでしょうか？',
    warnMsg: 'この操作はすべてのアカウントを緊急停止します。よろしいでしょうか？',
    confirmMsg: '確定したら、下のボックスに「サービス緊急停止」を入力してください。',
    cancelText: 'いいえ',
    confirmMsgError: '入力したメッセージは不正です。',
    okText: 'はい',
    successMsg: '処理が正常終了しました。',
    errorMsg: '処理が失敗しました。'
}
